export default {
  pleaseSelectProfilePicture:
    'لطفا لوگوی شرکت و یا عکس پروفایلتان را ارسال کنید.',
  profilePicture: 'لوگوی شرکت/ عکس پروفایل',
  pleaseSelectBackgroundPicture:
    'لطفا عکس پس‌زمینه‌ی پروفایل خودر را در صورت تمایل انتخاب کنید.',
  background: 'عکس پس زمینه‌ی پروفایل',
  chooseFile: 'انتخاب فایل',
  changeFile: 'تغییر عکس',
  edit: 'ویرایش',
  delete: 'حذف',
  cancel: 'لغو',
  confirm: 'تایید',
  verticalCarousels: 'بنرها در حالت موبایل',
  horizontalCarousels: 'بنرها در حالت دسکتاپ',
  backgroundVertical: 'تصویر پس زمینه در حالت عمودی',
  backgroundHorizontal: 'تصویر پس زمینه در حالت افقی',
  pleaseSelectVerticalBackgroundPicture:
    'لطفا عکس پس‌زمینه‌ی پس‌زمینه‌ی (در حالت عمودی) در صورت تمایل انتخاب کنید.',
  pleaseSelectHorizontalBackgroundPicture:
    'لطفا عکس پس‌زمینه‌ی  (در حالت افقی) در صورت تمایل انتخاب کنید.',
};
